import { useNavigate, useLocation } from 'react-router-dom'
import { useTheme } from '../../contexts/ThemeContext'
import { IcLeaf, IcSparkle, IcChart, IcFlower, IcWallet } from '../ui/Icons'

const tabs = [
  { path: '/',            Icon: IcLeaf,    label: 'Inicio'      },
  { path: '/resumen',     Icon: IcChart,   label: 'Resumen'     },
  { path: '/metas',       Icon: IcSparkle, label: 'Metas'       },
  { path: '/presupuesto', Icon: IcWallet,  label: 'Presupuesto', fontSize: 9 },
  { path: '/perfil',      Icon: IcFlower,  label: 'Yo'          },
]

export default function BottomNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { theme } = useTheme()

  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
      width: '100%', maxWidth: 560,
      background: theme.navBg,
      backdropFilter: 'blur(16px)',
      borderTop: `1px solid ${theme.navBorder}`,
      display: 'flex', padding: '10px 6px 18px', gap: 4,
      zIndex: 100,
    }}>
      {tabs.map(({ path, Icon, label, fontSize = 10.5 }) => {
        const active = pathname === path
        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            style={{
              flex: 1, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 3, background: 'none',
              border: 'none', cursor: 'pointer', padding: '8px 4px',
              borderRadius: 14, transition: 'all 0.2s',
              fontFamily: "'DM Sans', sans-serif",
              fontSize, fontWeight: active ? 600 : 500,
              color: active ? theme.accent : theme.inkLight,
              background: active ? theme.accent + '18' : 'none',
            }}
          >
            <Icon size={22} strokeWidth={active ? 1.8 : 1.5} />
            <span>{label}</span>
          </button>
        )
      })}
    </nav>
  )
}
